<template>
    <div>
        <h1 style="font-size: 24px; color: black;">归因黑名单配置</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="类型：">
                    <el-select v-model="queryData.k" placeholder="请选择">
                        <el-option
                                v-for="item in this.enum"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="position: relative; left:20px">
                    <el-button type="primary" @click="getList">查询</el-button>
                    </span>
                    <span style="position: relative; left:150px">
                        <el-button type="primary" @click="showSaveFormDialog('新增黑名单')">新增黑名单</el-button>
                    </span>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table border :data="list">
                <el-table-column prop="id" label="编号" align="center"></el-table-column>
                <el-table-column prop="k" label="类型" align="center" :formatter="enumFormatter"></el-table-column>
                <el-table-column prop="v" label="值" align="center"></el-table-column>
                <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                <el-table-column prop="createDt" label="创建时间" align="center"></el-table-column>
                <el-table-column prop="updateDt" label="修改时间" align="center"></el-table-column>
                <el-table-column label="开关" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabled"
                                   :active-value=true
                                   :inactive-value=false
                                   active-text="开启"
                                   inactive-text="关闭"
                                   @change="save(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="showSaveFormDialog('编辑配置',scope.row)">编辑
                        </el-button>
                        <el-button type="text" @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </h1>

        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px">
            <el-form :model="saveForm">
                <el-form-item label="类型：" :label-width="labelWidth">
                    <el-select v-model="saveForm.k">
                        <el-option
                            v-for="item in this.enum"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="值：" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.v"></el-input>
                </el-form-item>
                <el-form-item label="备注：" :label-width="labelWidth">
                    <el-input type="text" v-model="saveForm.remark"></el-input>
                </el-form-item>
                <el-form-item  label="是否可用：" :label-width="labelWidth">
                    <el-switch v-model="saveForm.enabled"
                               :active-value=true
                               :inactive-value=false
                               active-text="开启"
                               inactive-text="关闭">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button type="primary" @click="confirmForm">提 交</el-button>
                <el-button type="info" @click="dialogVisible=false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {deleteBlack, enumBlack, queryBlack, saveBlack} from '@/http/api'
import app from "@/App.vue";
import {dateTimeFormat} from "@/filters";

export default {
    name: "AttributionBlackList.vue",
    computed: {
        app() {
            return app
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            list: [],
            enum: [],
            saveForm: {
                id: null,
                k: null,
                v: null,
                remark: null,
                enabled: null
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            queryData: {},
        }
    },
    methods: {
        dateTimeFormat,
        enumFormatter: function (row, column, cellValue) {
            let temp = ""
            this.enum.forEach(item => {
                if (item.id === cellValue) {
                    temp = item.name;
                }
            })
            return temp
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.getList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.getList();
        },
        getList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            queryBlack(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements;
            });
        },
        remove(id) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteBlack(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.getList();
                    }
                });
            }).catch(() => {
            })
        },
        showSaveFormDialog(_title, _data) {
            this.dialogVisible = true;
            this.dialogTitle = _title;
            this.saveForm = {
                id: null,
                k: null,
                v: null,
                remark: null,
                enabled: null
            };
            if (_data) {
                this.saveForm = {
                    id: _data.id,
                    k: _data.k,
                    v: _data.v,
                    remark: _data.remark,
                    enabled: _data.enabled
                }
            }
        },
        confirmForm() {
            this.save(this.saveForm);
        },
        save(data) {
            saveBlack(data).then(resp => {
                if (resp.data.status === 0) {
                    this.getList();
                    this.dialogVisible = false;
                }
            });
        }

    },
    created() {
        this.getList();
        enumBlack().then(resp => {
            this.enum = resp.data.info;
        });
    }
}
</script>